import {TagTypes} from '@/components/tags-manager/tag-types';

export const emptyMessages = {
    [TagTypes.customer]: `This customer does not have any tags.`,
};

export const successMessages = {
    [TagTypes.customer]: `Customer's tags successfully updated`,
};

export const modalDescriptionMessages = {
    [TagTypes.customer]: `Add tags to this customer`,
};

export default {
    emptyMessages,
    successMessages,
    modalDescriptionMessages,
};
